import React, { FC } from 'react';

export interface OpThumbnailProps {
  src: string;
  size?: 'small-2x' | 'small-1x' | 'small' | 'medium' | 'large' | 'fluid';
  alt?: string;
  selected?: boolean;
  disabled?: boolean;
}

const OpThumbnail: FC<OpThumbnailProps> = ({ size, disabled = false, selected = false, src, alt }) => {
  const opThumbnailProps: OpThumbnailProps = {
    size,
    disabled: disabled || undefined,
    selected: selected || undefined,
    src,
    alt,
  };

  return React.createElement('op-thumbnail', opThumbnailProps);
};

export default OpThumbnail;
